import { Exit } from '../../types/vc';
import { SectionTitle } from './SectionTitle';

interface ExitListProps {
  exits: Exit[];
}

export function ExitList({ exits }: ExitListProps) {
  return (
    <div>
      <SectionTitle>Exits</SectionTitle>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {exits.map((exit, index) => (
          <div
            key={index}
            className="flex flex-col p-4 bg-gray-50 rounded-lg space-y-2"
          >
            <h5 className="text-sm font-medium text-gray-900">{exit.value}</h5>
            <p className="text-xs text-gray-600 line-clamp-2">{exit.description}</p>
            <a
              href={`https://www.crunchbase.com/organization/${exit.link}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-indigo-600 hover:text-indigo-800"
            >
              View on Crunchbase →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
} 